import { SvgProps } from "components/icons/types";

export const FilingsSparkle = (props: SvgProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 0.74707L7.25 4.49707L11 5.74707L7.25 6.99707L6 10.7471L4.75 6.99707L1 5.74707L4.75 4.49707L6 0.74707Z"
        fill="url(#filings_sparkle_g0)"
      />
      <path
        d="M12 8.5L12.75 10.75L15 11.5L12.75 12.25L12 14.5L11.25 12.25L9 11.5L11.25 10.75L12 8.5Z"
        fill="url(#filings_sparkle_g1)"
      />
      <defs>
        <linearGradient
          id="filings_sparkle_g0"
          x1="1"
          y1="5.74707"
          x2="11"
          y2="5.74707"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F59E0B" />
          <stop offset="1" stopColor="#A78BFA" />
        </linearGradient>
        <linearGradient
          id="filings_sparkle_g1"
          x1="9"
          y1="11.5"
          x2="15"
          y2="11.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F59E0B" />
          <stop offset="1" stopColor="#A78BFA" />
        </linearGradient>
      </defs>
    </svg>
  );
};
